import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { DBConfig, NgxIndexedDBModule } from 'ngx-indexed-db';
import { authInterceptor, provideAuth } from 'angular-auth-oidc-client';

import { routes } from './app.routes';
import { connectivityInterceptor } from './core/interceptors/retry-on-reconnect.interceptor';
import {
  IndexDBName,
} from './core/global/constants/constant';
import { GlobalErrorHandler } from './core/global-error-handler';
import { oidcConfig } from './auth/oidc.config';
import { httpRequestInterceptor } from './core/interceptors/http-request.interceptor';
import { environment } from '../environments/environment';

// The service worker (and its auto-updater) runs on every deployed environment,
// but never during local `ng serve`.
const isLocalHost =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);

const dbConfig: DBConfig = {
  name: 'SDeskDb',
  version: 1,
  objectStoresMeta: [{
    store: IndexDBName,
    storeConfig: {keyPath: 'key', autoIncrement: false},
    storeSchema: [
      { name: 'key', keypath: 'key', options: {unique: true} },
      { name: 'value', keypath: 'value', options: {unique: false} }
    ]
  }]
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideAnimations(),
    provideToastr(),
    provideHttpClient(withXhr(), 
      withInterceptors([connectivityInterceptor, authInterceptor(), httpRequestInterceptor])
    ),
    provideAuth(oidcConfig),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.enableServiceWorker && !isLocalHost,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    importProvidersFrom(
      NgxIndexedDBModule.forRoot(dbConfig),
    ),
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
};
